export default __webpack_public_path__ + "static/media/BackgroundSignIn.17f6489c.svg";